import React from "react";
import arrowUpIcon from "@/assets/images/icon-arrow-up-light-v2.svg";
import arrowDownIcon from "@/assets/images/icon-arrow-down-light-v2.svg";
import { formatCellText, getTrendDirection, toneForTrend } from "./kdbOddsUtils";

const TrendDot = ({ trend }) => {
  const dir = getTrendDirection(trend);
  if (!dir) return null;
  const isUp = dir === "up";
  return (
    <div
      className={`absolute -top-1 -right-1 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-current ${isUp ? "kdb-odds-up-text" : "kdb-odds-down-text"}`}
      style={{ animation: "blink 0.6s 3" }}
    >
      <img 
        src={isUp ? arrowUpIcon : arrowDownIcon} 
        alt={isUp ? "Up" : "Down"} 
        className="h-[10px] w-[10px]" 
      />
    </div>
  );
};

const Cell = ({ value, trend, fullWidth = false }) => (
  <div
    className={`relative flex h-[22px] items-center justify-center font-medium ${fullWidth ? "w-full" : "w-[55px]"
      } ${toneForTrend(trend)}`}
  >
    {formatCellText(value)}
    <TrendDot trend={trend} />
  </div>
);

export default function KdbOdds3({
  left,
  middle,
  right,
  leftTrend,
  middleTrend,
  rightTrend,
  fullWidth = false,
}) {
  return (
    <div
      className={`gap-2 py-2 ${fullWidth
        ? "grid w-full grid-cols-3"
        : "flex items-center justify-center"
        }`}
    >
      <Cell value={left} trend={leftTrend} fullWidth={fullWidth} />
      <Cell value={middle} trend={middleTrend} fullWidth={fullWidth} />
      <Cell value={right} trend={rightTrend} fullWidth={fullWidth} />
    </div>
  );
}
